/** 查询所有角色 */
export const getAllRole = '/role/listAll'

/** 查询所有站点 */
export const getAllSite = '/yuntian/country/queryAllCountryList'

/** 查询平台和站点下 所有的店铺 */
export const getAllStore = '/yuntian/store/queryStorePushList'

/** 级联选择：根据平台和站点获取店铺下拉列表 */
export const getStoreByPlatformAndCountry = '/yuntian/store/queryStoreByPlatformAndCountry'

/** 查询所有刷手 */
export const getAllService = '/admin/allServiceList'

/** 查询所有海外负责人 */
export const getAllLeaderList = '/admin/allLeaderList'

/** 查询所有的公司 */
export const getAllCompany = '/yuntian/company/queryCompanyList'

/** 查询商家所有站点 */
export const getAllCompanySite = '/admin/country/companyCountryList'

/** 查询所有站点  参数platformId*/
export const queryCountryList = '/yuntian/country/queryCountryList'

/** 查询所有站点  */
export const queryPlatformList = '/yuntian/platform/queryPlatformList'

/** 查询站点下所有仓库｜ 仓库可不传也行· */
export const getAllWarehouse = '/yuntian/warehouse/queryWarehouseByCountryCode'






// WEBPACK FOOTER //
// ./src/http/moudules/allApi.js